import { tavus } from "./client";
import type { SessionDataAdapter } from "../sessionAdapter";

/**
 * Tavus session data adapter. Both endpoints are backed by
 * `GET /v2/conversations/{id}?verbose=true` server-side; the edge
 * function normalizes the transcript to the same shape LiveAvatar
 * uses so the scoring service and storage layers do not branch per
 * provider. Tavus may lag briefly after `endConversation`, so we
 * apply the same short polling ladder used for LiveAvatar.
 */
export const tavusSessionAdapter: SessionDataAdapter = {
  async fetchSessionMeta(conversationId) {
    let last: Record<string, unknown> | null = null;
    const delays = [0, 1500, 3000];
    for (const d of delays) {
      if (d) await new Promise((r) => setTimeout(r, d));
      try {
        const res = await tavus.getConversation(conversationId);
        last = res as unknown as Record<string, unknown>;
        if (res && (res.duration ?? 0) > 0) break;
      } catch {
        /* retry */
      }
    }
    return last;
  },
  async fetchTranscript(conversationId) {
    let last: Awaited<ReturnType<typeof tavus.getConversationTranscript>> | null =
      null;
    const delays = [0, 1500, 3000, 4000];
    for (const d of delays) {
      if (d) await new Promise((r) => setTimeout(r, d));
      try {
        last = await tavus.getConversationTranscript(conversationId);
        if (last?.transcript_data?.length) break;
      } catch {
        /* retry */
      }
    }
    if (!last) return null;
    return {
      session_active: last.session_active,
      next_timestamp: last.next_timestamp,
      transcript_data: last.transcript_data ?? [],
      raw: last.raw,
    };
  },
};